import { render, staticRenderFns } from "./productSetting.vue?vue&type=template&id=bbeb57e6&scoped=true&"
import script from "./productSetting.vue?vue&type=script&lang=js&"
export * from "./productSetting.vue?vue&type=script&lang=js&"
import style0 from "./productSetting.vue?vue&type=style&index=0&id=bbeb57e6&prod&lang=css&"
import style1 from "./productSetting.vue?vue&type=style&index=1&id=bbeb57e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeb57e6",
  null
  
)

export default component.exports